import { render, staticRenderFns } from "./solutionDetail.vue?vue&type=template&id=798335e6&scoped=true"
import script from "./solutionDetail.vue?vue&type=script&lang=js"
export * from "./solutionDetail.vue?vue&type=script&lang=js"
import style0 from "./solutionDetail.vue?vue&type=style&index=0&id=798335e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798335e6",
  null
  
)

export default component.exports